/* eslint-disable max-len */
/* eslint-disable no-console */
import React from 'react';
import { Box, Tab } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import ApexBarChart from './bar-chart';
import ApexLineChart from './line-chart';
import ApexGroupLineChart from './line-chart_Group';

export default function Charts(props) {
  const { recovery_checked, data, product, Chartvalue, setChartValue, sliderRecoveryValue, isFeedComposition } = props;
  const ChartData = data?.graph_data_standalone || [];
  const barChartData = ChartData?.[isFeedComposition=== 'feed'?sliderRecoveryValue:0]?.[product] ?
    ChartData?.[isFeedComposition=== 'feed'?sliderRecoveryValue:0]?.[product] : [];

  // Single source of truth for MgOH2 visibility
  const isshowMgOH2 = ['MDC714', 'MDC712', 'MDC704i', 'MDC712E'].includes(product);

  // Convert object to series and apply MgOH2 filter when not applicable
  const barSeriesData = React.useMemo(() => {
    if (!barChartData) return [];
    const mapped = Array.isArray(barChartData)
      ? barChartData
      : Object.entries(barChartData).map(([element, value]) => ({
        name: element,
        data: value ?? 0,
      }));
    return isshowMgOH2 ? mapped : mapped.filter(item => item.name !== 'MgOH2');
  }, [barChartData, isshowMgOH2]);

  const lineChartData = data?.as_line_graph?.[product] || [];
  const lineChartRecoveryData = data?.recovery || 100;
  const handleChange = (event, newValue) => {
    setChartValue(newValue);
  };
  return (
    <TabContext value={Chartvalue}>
      <Box
        sx={{
          borderBottom: 1,
          width: '100%',
          borderColor: 'divider',
          maxWidth: { sm: '100%' },
          bgcolor: 'background.paper',
        }}
      >
        <TabList onChange={handleChange}
          variant="scrollable"
          scrollButtons
          aria-label="visible arrows tabs example"
        >
          <Tab label="Saturation" value="1" />
          <Tab label="Comparison" value="2" disabled={!recovery_checked} style={{ 'display': !recovery_checked ? 'none' : 'block' }} />
          <Tab label="S&DI / LSI" value="3" disabled={!recovery_checked} style={{ 'display': !recovery_checked ? 'none' : 'block' }} />
          <Tab label="CaSO4" value="4" disabled={!recovery_checked} style={{ 'display': !recovery_checked ? 'none' : 'block' }} />
          <Tab label="BaSO4" value="5" disabled={!recovery_checked} style={{ 'display': !recovery_checked ? 'none' : 'block' }} />
          <Tab label="SrSO4" value="6" disabled={!recovery_checked} style={{ 'display': !recovery_checked ? 'none' : 'block' }} />
          <Tab label="CaF2" value="7" disabled={!recovery_checked} style={{ 'display': !recovery_checked ? 'none' : 'block' }} />
          <Tab label="SiO2" value="8" disabled={!recovery_checked} style={{ 'display': !recovery_checked ? 'none' : 'block' }} />
          <Tab label="CaHPO4" value="9" disabled={!recovery_checked} style={{ 'display': !recovery_checked ? 'none' : 'block' }} />
          {/* {isshowMgOH2 && <Tab label="MgOH2" value="10" disabled={!recovery_checked} style={{ 'display': !recovery_checked ? 'none' : 'block' }} />} */}
        </TabList>
      </Box>
      <TabPanel value="1" >
        <div className="B_Bold" style={{
          'justifyContent': 'center',
          'display': 'flex'
        }}>Saturation Indices</div>
        <ApexBarChart barChartData={barSeriesData} Recoverychange={sliderRecoveryValue} isFeedComposition={isFeedComposition} />
      </TabPanel>
      <TabPanel value="2" >
        <div className="B_Bold" style={{
          'justifyContent': 'center',
          'display': 'flex'
        }}>Comparison of Saturation Index</div>
        <ApexGroupLineChart lineChartData={lineChartData || []}
          linevalue='Comparison of Saturation Index' lineChartRecoveryData={lineChartRecoveryData} />
      </TabPanel>
      <TabPanel value="3" >
        <div className="B_Bold" style={{
          'justifyContent': 'center',
          'display': 'flex'
        }}>S&DI/LSI</div>
        <ApexLineChart
          lineChartData={lineChartData ? lineChartData['LSI/SDI'] : []}
          linevalue='S&DI/LSI' lineChartRecoveryData={lineChartRecoveryData} />
      </TabPanel>
      <TabPanel value="4" >
        <div className="B_Bold" style={{
          'justifyContent': 'center',
          'display': 'flex'
        }}>Calcium Sulfate</div>
        <ApexLineChart lineChartData={lineChartData ? lineChartData.CaSO4 : []} linevalue='CaSO4' lineChartRecoveryData={lineChartRecoveryData} />
      </TabPanel>
      <TabPanel value="5" >
        <div className="B_Bold" style={{
          'justifyContent': 'center',
          'display': 'flex'
        }}>Barium Sulfate</div>
        <ApexLineChart lineChartData={lineChartData ? lineChartData.BaSO4 : []} linevalue='BaSO4' lineChartRecoveryData={lineChartRecoveryData} />
      </TabPanel>
      <TabPanel value="6" >
        <div className="B_Bold" style={{
          'justifyContent': 'center',
          'display': 'flex'
        }}>Strontium Sulfate</div>
        <ApexLineChart lineChartData={lineChartData ? lineChartData.SrSO4 : []} linevalue='SrSO4' lineChartRecoveryData={lineChartRecoveryData} />
      </TabPanel>
      <TabPanel value="7" >
        <div className="B_Bold" style={{
          'justifyContent': 'center',
          'display': 'flex'
        }}>Calcium Fluoride</div>
        <ApexLineChart lineChartData={lineChartData ? lineChartData.CaF2 : []} linevalue='CaF2' lineChartRecoveryData={lineChartRecoveryData} />
      </TabPanel>
      <TabPanel value="8" >
        <div className="B_Bold" style={{
          'justifyContent': 'center',
          'display': 'flex'
        }}>Silica</div>
        <ApexLineChart lineChartData={lineChartData ? lineChartData.SiO2 : []} linevalue='SiO2' lineChartRecoveryData={lineChartRecoveryData} />
      </TabPanel>
      <TabPanel value="9" >
        <div className="B_Bold" style={{
          'justifyContent': 'center',
          'display': 'flex'
        }}>Calcium Phosphate</div>
        <ApexLineChart lineChartData={lineChartData ? lineChartData.CaHPO4 : []} linevalue='CaHPO4' lineChartRecoveryData={lineChartRecoveryData} />
      </TabPanel>
      <TabPanel value="10" >
        <div className="B_Bold" style={{
          'justifyContent': 'center',
          'display': 'flex'
        }}>Magnesium Hydroxide</div>
        <ApexLineChart lineChartData={lineChartData ? lineChartData.MgOH2 : []} linevalue='MgOH2' lineChartRecoveryData={lineChartRecoveryData} />
      </TabPanel>
    </TabContext>
  );
}
